/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardBulkUpdateLicense,
  DashboardCreateLicense,
  DashboardDeleteLicense,
  DashboardLicenseEditorDetail,
  DashboardLicenseFormDetail,
  DashboardLicenseList,
  DashboardLicenseListItem,
  DashboardLicenseStats,
  DashboardLicensesControllerBulkUpdate400,
  DashboardLicensesControllerBulkUpdate401,
  DashboardLicensesControllerBulkUpdate404,
  DashboardLicensesControllerBulkUpdate429,
  DashboardLicensesControllerCreate400,
  DashboardLicensesControllerCreate401,
  DashboardLicensesControllerCreate404,
  DashboardLicensesControllerCreate429,
  DashboardLicensesControllerEditorDetail400,
  DashboardLicensesControllerEditorDetail401,
  DashboardLicensesControllerEditorDetail404,
  DashboardLicensesControllerEditorDetail429,
  DashboardLicensesControllerExport400,
  DashboardLicensesControllerExport401,
  DashboardLicensesControllerExport413,
  DashboardLicensesControllerExport429,
  DashboardLicensesControllerExportParams,
  DashboardLicensesControllerFormDetail400,
  DashboardLicensesControllerFormDetail401,
  DashboardLicensesControllerFormDetail404,
  DashboardLicensesControllerFormDetail429,
  DashboardLicensesControllerList400,
  DashboardLicensesControllerList401,
  DashboardLicensesControllerList429,
  DashboardLicensesControllerListParams,
  DashboardLicensesControllerRefs400,
  DashboardLicensesControllerRefs401,
  DashboardLicensesControllerRefs429,
  DashboardLicensesControllerRefsParams,
  DashboardLicensesControllerRemove400,
  DashboardLicensesControllerRemove401,
  DashboardLicensesControllerRemove403,
  DashboardLicensesControllerRemove404,
  DashboardLicensesControllerRemove409,
  DashboardLicensesControllerRemove429,
  DashboardLicensesControllerSearch400,
  DashboardLicensesControllerSearch401,
  DashboardLicensesControllerSearch429,
  DashboardLicensesControllerSearchParams,
  DashboardLicensesControllerStats400,
  DashboardLicensesControllerStats401,
  DashboardLicensesControllerStats429,
  DashboardLicensesControllerStatsParams,
  DashboardLicensesControllerUpdate400,
  DashboardLicensesControllerUpdate401,
  DashboardLicensesControllerUpdate404,
  DashboardLicensesControllerUpdate409,
  DashboardLicensesControllerUpdate429,
  DashboardUpdateLicense,
  LicenseRef,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated license list scoped to the caller: the `LICENSE:READ` RBAC capability universe (full-platform / full-federation / pair grants and league-level grants). `platformIds` and `federationIds` are pure filters applied together (AND of axes); the platform filter reads the authoritative `license.platformId` attribution — a platform-global license (no federation) appears under its platform, and a license with no platform attribution counts as a wildcard over the platforms its federation is linked to. The league filter is authoritative: when `leagueIds` is present the platform / federation filters are ignored and authorization narrows the requested league set instead. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Filters: keyword, federation / platform / sport / league ids, duration, status, type, sale-window dates, price + issued-count ranges, isAutoRenew, issued-on date range. Each row carries the slim license ref + fee schedule, status, isAutoRenew, and issued count.
 * @summary List licenses (dashboard)
 */
export const dashboardLicensesControllerList = (
  params?: DashboardLicensesControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseList>(
    { url: `/api/dashboard/v1/licenses`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLicensesControllerListQueryKey = (
  params?: DashboardLicensesControllerListParams
) => {
  return [`/api/dashboard/v1/licenses`, ...(params ? [params] : [])] as const;
};

export const getDashboardLicensesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
  TError = ErrorType<
    | DashboardLicensesControllerList400
    | DashboardLicensesControllerList401
    | DashboardLicensesControllerList429
  >,
>(
  params?: DashboardLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLicensesControllerList>>> = ({
    signal,
  }) => dashboardLicensesControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerList>>
>;
export type DashboardLicensesControllerListQueryError = ErrorType<
  | DashboardLicensesControllerList400
  | DashboardLicensesControllerList401
  | DashboardLicensesControllerList429
>;

export function useDashboardLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
  TError = ErrorType<
    | DashboardLicensesControllerList400
    | DashboardLicensesControllerList401
    | DashboardLicensesControllerList429
  >,
>(
  params: undefined | DashboardLicensesControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
  TError = ErrorType<
    | DashboardLicensesControllerList400
    | DashboardLicensesControllerList401
    | DashboardLicensesControllerList429
  >,
>(
  params?: DashboardLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
  TError = ErrorType<
    | DashboardLicensesControllerList400
    | DashboardLicensesControllerList401
    | DashboardLicensesControllerList429
  >,
>(
  params?: DashboardLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List licenses (dashboard)
 */

export function useDashboardLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerList>>,
  TError = ErrorType<
    | DashboardLicensesControllerList400
    | DashboardLicensesControllerList401
    | DashboardLicensesControllerList429
  >,
>(
  params?: DashboardLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a license row. `federation` is required for scoped callers (admins may omit). Sports, leagues, and the additional-questions schema are persisted in the same transaction. Returns the new editor detail.
 * @summary Create license (dashboard)
 */
export const dashboardLicensesControllerCreate = (
  dashboardCreateLicense: BodyType<DashboardCreateLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseEditorDetail>(
    {
      url: `/api/dashboard/v1/licenses`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLicense,
      signal,
    },
    options
  );
};

export const getDashboardLicensesControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLicensesControllerCreate400
    | DashboardLicensesControllerCreate401
    | DashboardLicensesControllerCreate404
    | DashboardLicensesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>,
    { data: BodyType<DashboardCreateLicense> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLicensesControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLicensesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>
>;
export type DashboardLicensesControllerCreateMutationBody = BodyType<DashboardCreateLicense>;
export type DashboardLicensesControllerCreateMutationError = ErrorType<
  | DashboardLicensesControllerCreate400
  | DashboardLicensesControllerCreate401
  | DashboardLicensesControllerCreate404
  | DashboardLicensesControllerCreate429
>;

/**
 * @summary Create license (dashboard)
 */
export const useDashboardLicensesControllerCreate = <
  TError = ErrorType<
    | DashboardLicensesControllerCreate400
    | DashboardLicensesControllerCreate401
    | DashboardLicensesControllerCreate404
    | DashboardLicensesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLicensesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLicense> },
  TContext
> => {
  const mutationOptions = getDashboardLicensesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggregate counts (all / active / inactive) under the same filter and caller scope as the list endpoint.
 * @summary Aggregate license counters (dashboard)
 */
export const dashboardLicensesControllerStats = (
  params?: DashboardLicensesControllerStatsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseStats>(
    { url: `/api/dashboard/v1/licenses/stats`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLicensesControllerStatsQueryKey = (
  params?: DashboardLicensesControllerStatsParams
) => {
  return [`/api/dashboard/v1/licenses/stats`, ...(params ? [params] : [])] as const;
};

export const getDashboardLicensesControllerStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardLicensesControllerStats400
    | DashboardLicensesControllerStats401
    | DashboardLicensesControllerStats429
  >,
>(
  params?: DashboardLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>> = ({
    signal,
  }) => dashboardLicensesControllerStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerStats>>
>;
export type DashboardLicensesControllerStatsQueryError = ErrorType<
  | DashboardLicensesControllerStats400
  | DashboardLicensesControllerStats401
  | DashboardLicensesControllerStats429
>;

export function useDashboardLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardLicensesControllerStats400
    | DashboardLicensesControllerStats401
    | DashboardLicensesControllerStats429
  >,
>(
  params: undefined | DashboardLicensesControllerStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardLicensesControllerStats400
    | DashboardLicensesControllerStats401
    | DashboardLicensesControllerStats429
  >,
>(
  params?: DashboardLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardLicensesControllerStats400
    | DashboardLicensesControllerStats401
    | DashboardLicensesControllerStats429
  >,
>(
  params?: DashboardLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Aggregate license counters (dashboard)
 */

export function useDashboardLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardLicensesControllerStats400
    | DashboardLicensesControllerStats401
    | DashboardLicensesControllerStats429
  >,
>(
  params?: DashboardLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batched id → ref lookup for filter-chip rehydration. Ids the caller cannot reach (different federation) are dropped silently from the response.
 * @summary Resolve license ids to slim refs (dashboard)
 */
export const dashboardLicensesControllerRefs = (
  params: DashboardLicensesControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LicenseRef[]>(
    { url: `/api/dashboard/v1/licenses/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLicensesControllerRefsQueryKey = (
  params: DashboardLicensesControllerRefsParams
) => {
  return [`/api/dashboard/v1/licenses/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardLicensesControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
  TError = ErrorType<
    | DashboardLicensesControllerRefs400
    | DashboardLicensesControllerRefs401
    | DashboardLicensesControllerRefs429
  >,
>(
  params: DashboardLicensesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>> = ({
    signal,
  }) => dashboardLicensesControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>
>;
export type DashboardLicensesControllerRefsQueryError = ErrorType<
  | DashboardLicensesControllerRefs400
  | DashboardLicensesControllerRefs401
  | DashboardLicensesControllerRefs429
>;

export function useDashboardLicensesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
  TError = ErrorType<
    | DashboardLicensesControllerRefs400
    | DashboardLicensesControllerRefs401
    | DashboardLicensesControllerRefs429
  >,
>(
  params: DashboardLicensesControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
  TError = ErrorType<
    | DashboardLicensesControllerRefs400
    | DashboardLicensesControllerRefs401
    | DashboardLicensesControllerRefs429
  >,
>(
  params: DashboardLicensesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
  TError = ErrorType<
    | DashboardLicensesControllerRefs400
    | DashboardLicensesControllerRefs401
    | DashboardLicensesControllerRefs429
  >,
>(
  params: DashboardLicensesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve license ids to slim refs (dashboard)
 */

export function useDashboardLicensesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>,
  TError = ErrorType<
    | DashboardLicensesControllerRefs400
    | DashboardLicensesControllerRefs401
    | DashboardLicensesControllerRefs429
  >,
>(
  params: DashboardLicensesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Keyword search across `title` + `englishTitle` for the dashboard licenses async-multi-select. `keyword` is optional and accepts 1+ chars when sent (case-insensitive token-AND `ILIKE` + `limit` cap absorb single-char noise). Bounded by `limit` (max 20) and the caller's federation scope; `platformIds` / `federationIds` / `leagueIds` / `status` narrow within that scope. Returns slim refs.
 * @summary License typeahead search (dashboard)
 */
export const dashboardLicensesControllerSearch = (
  params?: DashboardLicensesControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LicenseRef[]>(
    { url: `/api/dashboard/v1/licenses/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLicensesControllerSearchQueryKey = (
  params?: DashboardLicensesControllerSearchParams
) => {
  return [`/api/dashboard/v1/licenses/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardLicensesControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
  TError = ErrorType<
    | DashboardLicensesControllerSearch400
    | DashboardLicensesControllerSearch401
    | DashboardLicensesControllerSearch429
  >,
>(
  params?: DashboardLicensesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>> = ({
    signal,
  }) => dashboardLicensesControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>
>;
export type DashboardLicensesControllerSearchQueryError = ErrorType<
  | DashboardLicensesControllerSearch400
  | DashboardLicensesControllerSearch401
  | DashboardLicensesControllerSearch429
>;

export function useDashboardLicensesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
  TError = ErrorType<
    | DashboardLicensesControllerSearch400
    | DashboardLicensesControllerSearch401
    | DashboardLicensesControllerSearch429
  >,
>(
  params: undefined | DashboardLicensesControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
  TError = ErrorType<
    | DashboardLicensesControllerSearch400
    | DashboardLicensesControllerSearch401
    | DashboardLicensesControllerSearch429
  >,
>(
  params?: DashboardLicensesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
  TError = ErrorType<
    | DashboardLicensesControllerSearch400
    | DashboardLicensesControllerSearch401
    | DashboardLicensesControllerSearch429
  >,
>(
  params?: DashboardLicensesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary License typeahead search (dashboard)
 */

export function useDashboardLicensesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>,
  TError = ErrorType<
    | DashboardLicensesControllerSearch400
    | DashboardLicensesControllerSearch401
    | DashboardLicensesControllerSearch429
  >,
>(
  params?: DashboardLicensesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set with parity against `GET /licenses`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Fixed column schema: ID, Title, Duration, Status, Fee, Currency, Issued count, Organization, Platforms, Sports, Start date, End date.
 * @summary Export licenses (dashboard)
 */
export const dashboardLicensesControllerExport = (
  params: DashboardLicensesControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/licenses/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardLicensesControllerExportQueryKey = (
  params: DashboardLicensesControllerExportParams
) => {
  return [`/api/dashboard/v1/licenses/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardLicensesControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardLicensesControllerExport400
    | DashboardLicensesControllerExport401
    | DashboardLicensesControllerExport413
    | DashboardLicensesControllerExport429
  >,
>(
  params: DashboardLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>> = ({
    signal,
  }) => dashboardLicensesControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerExport>>
>;
export type DashboardLicensesControllerExportQueryError = ErrorType<
  | DashboardLicensesControllerExport400
  | DashboardLicensesControllerExport401
  | DashboardLicensesControllerExport413
  | DashboardLicensesControllerExport429
>;

export function useDashboardLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardLicensesControllerExport400
    | DashboardLicensesControllerExport401
    | DashboardLicensesControllerExport413
    | DashboardLicensesControllerExport429
  >,
>(
  params: DashboardLicensesControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardLicensesControllerExport400
    | DashboardLicensesControllerExport401
    | DashboardLicensesControllerExport413
    | DashboardLicensesControllerExport429
  >,
>(
  params: DashboardLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardLicensesControllerExport400
    | DashboardLicensesControllerExport401
    | DashboardLicensesControllerExport413
    | DashboardLicensesControllerExport429
  >,
>(
  params: DashboardLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export licenses (dashboard)
 */

export function useDashboardLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardLicensesControllerExport400
    | DashboardLicensesControllerExport401
    | DashboardLicensesControllerExport413
    | DashboardLicensesControllerExport429
  >,
>(
  params: DashboardLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLicensesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * License detail projected for the create / update purchased-license form: fee schedule, manager-pays flags, eligibility gates, federation ref, and the embedded `additionalQuestions[]` schema so the form renders the questions step without a second fetch. Form-scoped projection — use `GET /:id` for the editor.
 * @summary Get license detail for the purchased-license form (dashboard)
 */
export const dashboardLicensesControllerFormDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseFormDetail>(
    { url: `/api/dashboard/v1/licenses/${id}/for-purchased-license-form`, method: "GET", signal },
    options
  );
};

export const getDashboardLicensesControllerFormDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/licenses/${id}/for-purchased-license-form`] as const;
};

export const getDashboardLicensesControllerFormDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerFormDetail400
    | DashboardLicensesControllerFormDetail401
    | DashboardLicensesControllerFormDetail404
    | DashboardLicensesControllerFormDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerFormDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>
  > = ({ signal }) => dashboardLicensesControllerFormDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerFormDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>
>;
export type DashboardLicensesControllerFormDetailQueryError = ErrorType<
  | DashboardLicensesControllerFormDetail400
  | DashboardLicensesControllerFormDetail401
  | DashboardLicensesControllerFormDetail404
  | DashboardLicensesControllerFormDetail429
>;

export function useDashboardLicensesControllerFormDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerFormDetail400
    | DashboardLicensesControllerFormDetail401
    | DashboardLicensesControllerFormDetail404
    | DashboardLicensesControllerFormDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerFormDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerFormDetail400
    | DashboardLicensesControllerFormDetail401
    | DashboardLicensesControllerFormDetail404
    | DashboardLicensesControllerFormDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerFormDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerFormDetail400
    | DashboardLicensesControllerFormDetail401
    | DashboardLicensesControllerFormDetail404
    | DashboardLicensesControllerFormDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get license detail for the purchased-license form (dashboard)
 */

export function useDashboardLicensesControllerFormDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerFormDetail400
    | DashboardLicensesControllerFormDetail401
    | DashboardLicensesControllerFormDetail404
    | DashboardLicensesControllerFormDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerFormDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerFormDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Full editor detail — strict super-set of the form detail with `englishTitle`, `translations`, `status`, `isAutoRenew`, `isManagerPayingStripeFee`, age-bound type hints, the license manager ref, sports, and bound leagues.
 * @summary Get license editor detail (dashboard)
 */
export const dashboardLicensesControllerEditorDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseEditorDetail>(
    { url: `/api/dashboard/v1/licenses/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardLicensesControllerEditorDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/licenses/${id}`] as const;
};

export const getDashboardLicensesControllerEditorDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerEditorDetail400
    | DashboardLicensesControllerEditorDetail401
    | DashboardLicensesControllerEditorDetail404
    | DashboardLicensesControllerEditorDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLicensesControllerEditorDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>
  > = ({ signal }) => dashboardLicensesControllerEditorDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLicensesControllerEditorDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>
>;
export type DashboardLicensesControllerEditorDetailQueryError = ErrorType<
  | DashboardLicensesControllerEditorDetail400
  | DashboardLicensesControllerEditorDetail401
  | DashboardLicensesControllerEditorDetail404
  | DashboardLicensesControllerEditorDetail429
>;

export function useDashboardLicensesControllerEditorDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerEditorDetail400
    | DashboardLicensesControllerEditorDetail401
    | DashboardLicensesControllerEditorDetail404
    | DashboardLicensesControllerEditorDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerEditorDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerEditorDetail400
    | DashboardLicensesControllerEditorDetail401
    | DashboardLicensesControllerEditorDetail404
    | DashboardLicensesControllerEditorDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLicensesControllerEditorDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerEditorDetail400
    | DashboardLicensesControllerEditorDetail401
    | DashboardLicensesControllerEditorDetail404
    | DashboardLicensesControllerEditorDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get license editor detail (dashboard)
 */

export function useDashboardLicensesControllerEditorDetail<
  TData = Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
  TError = ErrorType<
    | DashboardLicensesControllerEditorDetail400
    | DashboardLicensesControllerEditorDetail401
    | DashboardLicensesControllerEditorDetail404
    | DashboardLicensesControllerEditorDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLicensesControllerEditorDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLicensesControllerEditorDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update. Scalar fields are written when present, left as-is when absent. Collection fields (`leagues`, `sports`, `additionalQuestions`) are replace-all when present: the submitted array IS the new state. License → federation re-binding is not exposed through this surface.
 * @summary Update license (dashboard)
 */
export const dashboardLicensesControllerUpdate = (
  id: string,
  dashboardUpdateLicense: BodyType<DashboardUpdateLicense>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardLicenseEditorDetail>(
    {
      url: `/api/dashboard/v1/licenses/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLicense,
    },
    options
  );
};

export const getDashboardLicensesControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLicensesControllerUpdate400
    | DashboardLicensesControllerUpdate401
    | DashboardLicensesControllerUpdate404
    | DashboardLicensesControllerUpdate409
    | DashboardLicensesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardLicensesControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLicensesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>
>;
export type DashboardLicensesControllerUpdateMutationBody = BodyType<DashboardUpdateLicense>;
export type DashboardLicensesControllerUpdateMutationError = ErrorType<
  | DashboardLicensesControllerUpdate400
  | DashboardLicensesControllerUpdate401
  | DashboardLicensesControllerUpdate404
  | DashboardLicensesControllerUpdate409
  | DashboardLicensesControllerUpdate429
>;

/**
 * @summary Update license (dashboard)
 */
export const useDashboardLicensesControllerUpdate = <
  TError = ErrorType<
    | DashboardLicensesControllerUpdate400
    | DashboardLicensesControllerUpdate401
    | DashboardLicensesControllerUpdate404
    | DashboardLicensesControllerUpdate409
    | DashboardLicensesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLicensesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateLicense> },
  TContext
> => {
  const mutationOptions = getDashboardLicensesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Soft-delete the license (sets `deletedAt`) — the audit trail stays queryable. Rejected with 409 when the license has any issued purchase: a license that has ever been issued must be deactivated rather than deleted. Requires the caller's current password in the body as an explicit confirmation gate (re-validates against the JWT subject's account) so the admin actively reproves they are at the keyboard. Returns 204.
 * @summary Delete license (dashboard)
 */
export const dashboardLicensesControllerRemove = (
  id: string,
  dashboardDeleteLicense: BodyType<DashboardDeleteLicense>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/licenses/${id}`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: dashboardDeleteLicense,
    },
    options
  );
};

export const getDashboardLicensesControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardLicensesControllerRemove400
    | DashboardLicensesControllerRemove401
    | DashboardLicensesControllerRemove403
    | DashboardLicensesControllerRemove404
    | DashboardLicensesControllerRemove409
    | DashboardLicensesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>,
    TError,
    { id: string; data: BodyType<DashboardDeleteLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>,
  TError,
  { id: string; data: BodyType<DashboardDeleteLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>,
    { id: string; data: BodyType<DashboardDeleteLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardLicensesControllerRemove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLicensesControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>
>;
export type DashboardLicensesControllerRemoveMutationBody = BodyType<DashboardDeleteLicense>;
export type DashboardLicensesControllerRemoveMutationError = ErrorType<
  | DashboardLicensesControllerRemove400
  | DashboardLicensesControllerRemove401
  | DashboardLicensesControllerRemove403
  | DashboardLicensesControllerRemove404
  | DashboardLicensesControllerRemove409
  | DashboardLicensesControllerRemove429
>;

/**
 * @summary Delete license (dashboard)
 */
export const useDashboardLicensesControllerRemove = <
  TError = ErrorType<
    | DashboardLicensesControllerRemove400
    | DashboardLicensesControllerRemove401
    | DashboardLicensesControllerRemove403
    | DashboardLicensesControllerRemove404
    | DashboardLicensesControllerRemove409
    | DashboardLicensesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>,
    TError,
    { id: string; data: BodyType<DashboardDeleteLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLicensesControllerRemove>>,
  TError,
  { id: string; data: BodyType<DashboardDeleteLicense> },
  TContext
> => {
  const mutationOptions = getDashboardLicensesControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Apply the same patch to every id in `licenseIds[]` inside a single transaction. Atomic — an out-of-scope id (or one that does not exist) fails the whole transaction with 404 and rolls every other row back. Audited per row. Returns the updated rows in list-item shape so the FE can replace the table rows without an extra fetch.
 * @summary Bulk-update licenses (dashboard)
 */
export const dashboardLicensesControllerBulkUpdate = (
  dashboardBulkUpdateLicense: BodyType<DashboardBulkUpdateLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseListItem[]>(
    {
      url: `/api/dashboard/v1/licenses/bulk-update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardBulkUpdateLicense,
      signal,
    },
    options
  );
};

export const getDashboardLicensesControllerBulkUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLicensesControllerBulkUpdate400
    | DashboardLicensesControllerBulkUpdate401
    | DashboardLicensesControllerBulkUpdate404
    | DashboardLicensesControllerBulkUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>,
    TError,
    { data: BodyType<DashboardBulkUpdateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>,
  TError,
  { data: BodyType<DashboardBulkUpdateLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>,
    { data: BodyType<DashboardBulkUpdateLicense> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLicensesControllerBulkUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLicensesControllerBulkUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>
>;
export type DashboardLicensesControllerBulkUpdateMutationBody =
  BodyType<DashboardBulkUpdateLicense>;
export type DashboardLicensesControllerBulkUpdateMutationError = ErrorType<
  | DashboardLicensesControllerBulkUpdate400
  | DashboardLicensesControllerBulkUpdate401
  | DashboardLicensesControllerBulkUpdate404
  | DashboardLicensesControllerBulkUpdate429
>;

/**
 * @summary Bulk-update licenses (dashboard)
 */
export const useDashboardLicensesControllerBulkUpdate = <
  TError = ErrorType<
    | DashboardLicensesControllerBulkUpdate400
    | DashboardLicensesControllerBulkUpdate401
    | DashboardLicensesControllerBulkUpdate404
    | DashboardLicensesControllerBulkUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>,
    TError,
    { data: BodyType<DashboardBulkUpdateLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLicensesControllerBulkUpdate>>,
  TError,
  { data: BodyType<DashboardBulkUpdateLicense> },
  TContext
> => {
  const mutationOptions = getDashboardLicensesControllerBulkUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
